<template>
    <history-wheel :wheel="data.wheel.contentJson" :phaseIndex="data.phase"></history-wheel>
</template>

<script>
import historyWheel from './../history-wheel/history-wheel'

export default {
  name: 'history-wheel-modal',
  components: {
    historyWheel
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  methods: {
    resize () {
      var size = Math.min(window.innerWidth * 80 / 100, window.innerHeight * 80 / 100)
      this.$el.style.width = size + 'px'
      this.$el.style.height = size + 'px'
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.resize()
    })

    this.resize()
  }
}
</script>
